import { render } from "./NCIndex.vue?vue&type=template&id=0c97270c"
import script from "./NCIndex.vue?vue&type=script&lang=js"
export * from "./NCIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__